import { useEffect, useState } from "react";

import { Checkbox } from "../Checkbox";
import { Container, Title } from "./style";
import { useLoadingProfileContext } from "../../pages/app/Profiles/profile-hook";
import { SpinnerProgress } from "../Spinner";

interface IIdPair {
  optionId: string | number;
  actionId: string | number;
  systemObjectUserCustomerProfileActionId?: string | number;
  soUserCustomerProfileId?: string | number;
  active: boolean;
}

interface Props {
  systemObjectCustomerId: any;
  id?: any;
  label?: string;
  checked?: any;
  style?: any;
  systemActionId?: number;
  soUserCustomerProfileId?: any;
  name?: any;
  userCustomerProfileId?: any;
  systemObjectUserCustomerProfileActionId?: any;
  onChange: (value: IIdPair) => void;
  isCreateNewProfile: boolean;
  loadingUpdate: boolean;
}

export function CheckBoxProfile({
  label,
  checked,
  style,
  id,
  systemActionId,
  soUserCustomerProfileId,
  userCustomerProfileId,
  systemObjectCustomerId,
  systemObjectUserCustomerProfileActionId,
  onChange,
  isCreateNewProfile = false,
  loadingUpdate,
}: Props) {
  const [active, setActive] = useState(checked);
  const [itemSelected, setItemSelected] = useState({
    systemActionId,
    soUserCustomerProfileId,
    id,
  });
  const [isFirstRender, setIsFirstRender] = useState(true);
  const [loadingCheckbox, setLoadingCheckbox] = useState(false);
  const { loadingProfile, setLoadingProfile } = useLoadingProfileContext();

  useEffect(() => {
    if (isFirstRender) {
      setIsFirstRender(false);
      return;
    }

    const processChange = () => {
      setLoadingCheckbox(true);
      setLoadingProfile(true);

      try {
        onChange({
          optionId: id,
          actionId: systemActionId!,
          systemObjectUserCustomerProfileActionId:
            systemObjectUserCustomerProfileActionId,
          soUserCustomerProfileId: soUserCustomerProfileId,
          active,
        });
      } catch (error) {
        console.error("Erro ao processar mudança de checkbox:", error);
      } finally {
        setLoadingCheckbox(false);
        setLoadingProfile(false);
      }
    };

    processChange();
  }, [active]);

  function handleDeactivateSelection() {
    const createDeleteData = JSON.parse(
      localStorage.getItem("deleteActionProfile")!,
    );
    const deleteAll = createDeleteData ?? [];
    deleteAll.push(systemObjectUserCustomerProfileActionId);
    localStorage.setItem("deleteActionProfile", JSON.stringify(deleteAll));

    if (!isCreateNewProfile) {
      return;
    }

    const createdList = localStorage.getItem("createList");
    const storedNewList = JSON.parse(createdList != null ? createdList : "");
    const updatedNewList = storedNewList?.filter(
      (itemInList: any) =>
        !(
          itemInList?.actionsList?.[0]?.id === id &&
          itemInList?.actionsList?.[0]?.systemActionId === systemActionId
        ),
    );
    localStorage.setItem("createList", JSON.stringify(updatedNewList));
  }

  function handleActivateSelection() {
    setItemSelected((itemSelected) => ({
      ...itemSelected,
      systemActionId,
      soUserCustomerProfileId,
      id,
      systemObjectCustomerId,
    }));

    if (isCreateNewProfile) {
      const createData = JSON.parse(localStorage.getItem("createList")!);
      const newCreateData = createData ? createData : [];
      newCreateData.push({
        systemObjectCustomerId: systemObjectCustomerId,
        actionsList: [
          {
            id: id,
            soUserCustomerProfileId: soUserCustomerProfileId,
            systemActionId: systemActionId,
          },
        ],
      });

      localStorage.setItem("createList", JSON.stringify(newCreateData));
    }

    const updateData = JSON.parse(localStorage.getItem("newList")!);
    const newData = updateData ? updateData : [];
    newData.push({
      soUserCustomerProfileId: soUserCustomerProfileId,
      systemActionId: systemActionId,
    });
    localStorage.setItem("newList", JSON.stringify(newData));

    const newUpdateData = JSON.parse(localStorage.getItem("newUpdateList")!);
    const newUpData = newUpdateData ? newUpdateData : [];
    newUpData.push({
      userCustomerProfileId: userCustomerProfileId,
      systemObjectCustomerId: id,
    });
    localStorage.setItem("newUpdateList", JSON.stringify(newUpData));

    setItemSelected(newData);
  }

  function handleSelected() {
    if (loadingProfile || loadingUpdate || loadingCheckbox) {
      return;
    }

    const isActivating = !active;
    setActive(isActivating);

    if (!isActivating) {
      handleDeactivateSelection();
      return;
    }

    if (itemSelected) {
      handleActivateSelection();
    }
  }

  return (
    <Container style={style} disableInteractions={loadingProfile}>
      <Checkbox
        id={`option-${id}-action-${systemActionId}`}
        checked={active}
        disabled={loadingProfile || loadingUpdate || loadingCheckbox}
        onChange={handleSelected}
      />

      <Title>{label}</Title>
    </Container>
  );
}
